module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-bar"
  }, [_c('input', {
    ref: "search",
    staticClass: "input text",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('label.search'),
      "v-model": _vm.searchQuery
    },
    on: {
      "blur": function($event) {
        _vm.focusLost()
      },
      "focus": function($event) {
        _vm.searchResults.length > 0 ? _vm.showSearchResults() : _vm.hideSearchResults()
      },
      "keyup": function($event) {
        _vm.$data.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "search-results",
    class: _vm.searchResultsShown ? 'shown' : ''
  }, _vm._l((_vm.searchResults), function(article) {
    return _c('li', {
      key: article.id,
      staticClass: "row",
      on: {
        "click": function($event) {
          _vm.showArticle(article.articleTranslations[0].slug)
        }
      }
    }, [_c('div', {
      staticClass: "inner col-lg-8 col-md-12"
    }, [_c('div', {
      staticClass: "type"
    }, [_vm._v(_vm._s(article.articleType.name))]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.formatDate(article.publishDate)))]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(article.articleTranslations[0].title))])]), _vm._v(" "), _c('div', {
      staticClass: "image col-4 hidden-sm-down",
      style: ('background: url(' + (article.image != null ? article.image : '/static/placeholders/placeholder-logo.jpg') + ') center center; background-size: cover;')
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14e79f93"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/SearchComponent.vue
// module id = 498
// module chunks = 1